import { render, staticRenderFns } from "./AddrEditor.vue?vue&type=template&id=005c6bb1"
import script from "./AddrEditor.vue?vue&type=script&lang=js"
export * from "./AddrEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports